import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import { IoIosArrowForward } from 'react-icons/io';
import Footer from '../components/Footer';
import NavbarText from '../components/NavbarText';
import FirstStep from "../components/foreigner/FirstStep";
import SecondStep from "../components/foreigner/SecondStep";
import {TBMEquipment, TBMEvntList} from "../interface/Interface";
import Snackbar from "../components/Snackbar";

export default function SignUpForeigner() {
    const navigate = useNavigate();
    const btnRef = useRef<any>();
    const [tab, setTab] = useState(0);
    const [userName, setUserName] = useState('');
    const [signature, setSignature] = useState('');
    const [saving, setSaving] = useState(false);
    const [selectedExbtPlcList, setSelectedExbtPlcList] = useState<string[]>([]);
    const [evntSeq, setEvntSeq] = useState(0);
    const [evntList, setEvntList] = useState<TBMEvntList>({ '전시장1': null, '전시장2': null });
    const [tabMoving, setTabMoving] = useState(false);
    const [checked, setChecked] = useState<TBMEquipment>({ cap: true, belt: false, shoes: false });
    const [snackbarTxt, setSnackbarTxt] = useState('');

    useEffect(() => { fn_exbtPlcList(); }, []);
    useEffect(() => { if (saving) { fn_loginTbmStrt(); } }, [saving]);
    useEffect(() => { if (snackbarTxt) { setTimeout(() => setSnackbarTxt(''), 2000) } }, [snackbarTxt]);

    const backEvent = () => {
        if (tab === 0) { navigate(-1) }
        setTab(prevState => prevState - 1);
    };

    const fn_exbtPlcList = async () => {
        const rtrnData = await fn_retrieveEvntSeqByExbtPlc();
        setEvntList(rtrnData);
    }

    const exbtPlcHandler = (paramExbtPlc: string, paramEvntSeq: number) => {
        if (selectedExbtPlcList.includes(paramExbtPlc)) {
            let temp = selectedExbtPlcList.filter((exbtPlc: string) => exbtPlc !== paramExbtPlc);
            temp.length === 0 && setEvntSeq(0);
            setSelectedExbtPlcList(temp);
        } else {
            if (evntSeq !== 0 && evntSeq !== paramEvntSeq) { setSnackbarTxt('여러 행사를 동시에 신고할 수 없습니다. 장소를 확인해주세요.'); return; }
            setSelectedExbtPlcList(selectedExbtPlcList.concat(paramExbtPlc));
            setEvntSeq(paramEvntSeq)
        }
    };

    const fn_loginStrtBtn = () => {
        btnRef.current.setAttribute("readonly", "readonly");
        setSaving(true);
    };

    const fn_loginTbmStrt = async () => {
        let equipList = [];
        for (let key in checked) { checked[key] && equipList.push(key) };
        const equipChk = equipList.join();

        const rtrnData = await axios.post('admin/api/tbm/retrieveTodayForeignerTbmData');
        let foreignCnt = rtrnData.data.foreignerWrkrCnt.toString();
        let userPhone = '010' + foreignCnt.padStart(8, '0');

        const formData = new FormData();
        const jsonObject = {
            userSeq: -7,
            tbmPrcsStat: '003',
            authSeq: 4,
            cmpnySeq: 791,
            evntSeq: evntSeq,
            sctrGb: '017',
            equipChk: equipChk,
            wrkDclrSeq: 0,
            userPhone: userPhone,
            userNm: userName,
            foreigner: true,
            sign: signature,
        };
        formData.append('jsonData', JSON.stringify(jsonObject));

        await axios.post('admin/api/user/saveForeignerTbmData', formData);

        navigate('/foreigner-done', { state : { userName: userName }});
    }
    return (
        <div className='w-screen h-[calc(100dvh)] relative z-20'>
            <NavbarText backEvent={backEvent} noneMenu>Sign up</NavbarText>
            {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
            {(tab === 0) || (tab === 1) ?
            <FirstStep tabMoving={tabMoving} setTabMoving={setTabMoving} setSnackbarTxt={setSnackbarTxt} signature={signature} setSignature={setSignature} tab={tab} setTab={setTab} setUserName={setUserName} userName={userName} exbtPlcHandler={exbtPlcHandler} selectedExbtPlcList={selectedExbtPlcList} evntList={evntList} />  :
            <SecondStep tab={tab} setTab={setTab} btnRef={btnRef} fn_loginStrtBtn={fn_loginStrtBtn} checked={checked} setChecked={setChecked} /> }
            <Footer />
        </div>
    );
}

const fn_retrieveEvntSeqByExbtPlc = async () => {
    const rtrnData = await axios.post('admin/api/tbm/retrieveEvntSeqByExbtPlc');
    return rtrnData.data;
}